// eslint-disable-next-line import/no-anonymous-default-export
export default {
  colorScheme: "light",

  colors: {
    "deep-blue": ["#011951", "#4C85BC"],
    gold: ["#BBA334", "#F9F9D6"],
    error: ["#D87B3D"],
    success: ["#87B84C"],
    title: ["#37393A"],
    subtitle: ["#595B5D"],
  },

  fontFamily: "Open Sans",
};
